// extracted by mini-css-extract-plugin
export default {"layerTwo":"layer-two_layerTwo__cK+SY","layerTwoSvg":"layer-two_layerTwoSvg__+XKZx","gradient":"layer-two_gradient__PLpsh"};